<div
    class="flex flex-column justify-content-center align-items-center w-full md:px-8 pb-3"
>
    <img
        src="/assets/images/modals/coming-soon-pool-lady-800.webp"
        alt="Coming Soon"
        class="w-full"
    />
    <h2 class="text-center mt-0">
        Put savings on autopilot with price tracking
    </h2>
    <span class="text text-center"
        >Never overpay for a flight. We alert you when it's the best time to
        book and help you get money back if the price drops after you've
        booked.</span
    >
    <div class="w-full grid mt-4">
        <div class="col-12 py-2">
            <p-button
                label="Notify Me"
                styleClass="learn-btn w-full"
                severity="info"
                (click)="clickJoin()"
            ></p-button>
        </div>
    </div>
</div>
